import { Component, Input, OnInit } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'kendo-grid-cell-date',
  template: `
    <div class="label-date">
      {{ getDate(text) }} 
    </div>`,
  styles: [`
    .label-date {
      text-align: center;
    }`],
})
export class KendoGridCellDateComponent implements OnInit {

  @Input() text: string = '';
  @Input() time: boolean = false;

  protected format: string;

  constructor(protected intl: IntlService) { }

  protected getDate(s: string): String {  

    if (s == null || s == '') {
      return '';
    }
    else {
      this.format = "dd-MMM-yyyy" + ((this.time) ? " HH:mm:ss": "" );
      const tzDate = ZonedDate.fromUTCDate(new Date(s), environment.timezone);
      return this.intl.formatDate(tzDate, this.format);
    }
    

  }

  ngOnInit() {
  }

}
